import { InjectionToken } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const REGISTER_ENABLED: InjectionToken<boolean> = new InjectionToken<boolean>('registerEnabled', {
  factory: () => true
});
